import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { getMediaManagerSDKFileExtension, getMediaProducer } from '../../media-manager-sdk/items';
import { mediaManagerMediaPurchaseCompleted } from '@wix/bi-logger-media-data/v2';

export const useTrackPurchaseAnalytics = () =>
  useMemo(
    () => ({
      trackMediaManagerMediaPurchaseCompleted: ({ item, isNew, category, tabName }) => {
        const { name, id: fileId, mediaType } = item;

        bi.logger().report(
          mediaManagerMediaPurchaseCompleted({
            name,
            fileId,
            mediaType,
            category,
            mediaProducer: getMediaProducer(item),
            fileFormat: getMediaManagerSDKFileExtension(item),
            isNew,
            ...(tabName ? { tabName } : {}),
          }),
        );
      },
    }),
    [],
  );
